import { useApp } from 'context/app-context'
import Script from 'next/script'

const HubspotScript = () => {
  const { env } = useApp()
  const hubspotId = env.HUBSPOT_ID

  if (!hubspotId) {
    return null
  }

  return (
    <Script
      type="text/javascript"
      id="hs-script-loader"
      async
      defer
      data-testid="hubspot-script"
      src={`//js.hs-scripts.com/${hubspotId}.js`}
    />
  )
}

export default HubspotScript
